import { render, staticRenderFns } from "./cancelBox.vue?vue&type=template&id=24aaebc5&scoped=true&"
import script from "./cancelBox.vue?vue&type=script&lang=js&"
export * from "./cancelBox.vue?vue&type=script&lang=js&"
import style0 from "./cancelBox.vue?vue&type=style&index=0&id=24aaebc5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24aaebc5",
  null
  
)

export default component.exports